document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('.drawer-link');
  const closeBtn = e.target.closest('.custom-drawer__close');
  const overlay = e.target.closest('.custom-drawer__overlay');

  // Abrir
  if (openBtn) {
    const id = openBtn.getAttribute('data-drawer');
    const drawer = document.getElementById(id);
    if (!drawer) return;

    drawer.classList.add('active');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('drawer-open'); // ✅
    return;
  }

  // Cerrar
  if (closeBtn || overlay) {
    const drawer = (closeBtn || overlay).closest('.custom-drawer');
    if (!drawer) return;

    drawer.classList.remove('active');

    // si no queda ningún drawer abierto, quitamos clases globales
    if (!document.querySelector('.custom-drawer.active')) {
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('drawer-open'); // ✅
    }
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;

  const openDrawer = document.querySelector('.custom-drawer.active');
  if (!openDrawer) return;

  openDrawer.classList.remove('active');

  if (!document.querySelector('.custom-drawer.active')) {
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('drawer-open'); // ✅
  }
});